module.exports = __webpack_public_path__ + "img/mall.20e5249f.png";